import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "framework"
    }}>{`Framework`}</h1>
    <p>{`Topics in this section include:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "array-manager.md"
        }}><strong parentName="a">{`Array manager`}</strong></a>{`—Manage deeply nested associative arrays.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "datetime-library.md"
        }}><strong parentName="a">{`DateTime library`}</strong></a>{`—Manipulate date and time formatting.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "float-comparator.md"
        }}><strong parentName="a">{`Float comparator`}</strong></a>{`—Compare float values with an appropriate epsilon value.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "serialize-library.md"
        }}><strong parentName="a">{`Serialize library`}</strong></a>{`—Manage data serialization.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "math-random.md"
        }}><strong parentName="a">{`Math random`}</strong></a>{`—Generate random number values and hashes.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "url-library.md"
        }}><strong parentName="a">{`URL library`}</strong></a>{`—Work with URLs.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      